import { ReactComponent as PeoplesSafe } from "assets/SidebarIcons/peoplesafeone.svg";
import { ReactComponent as PeoplesSafeOffline } from "assets/people-safe-offline.svg";
import { ReactComponent as Car } from "assets/Cards/car.svg";
import { ReactComponent as Home } from "assets/Cards/home.svg";
import { ReactComponent as Shop } from "assets/shop.svg";

import { FilterOption } from "../MapMenu";
import { AddMapOption } from "../MapAddButton";

export function isFilterActive(filters: FilterOption, key: string) {
  return filters[key] && filters[key].active;
}

export const addOptionList: AddMapOption[] = [
  {
    id: "store",
    label: "Estabelecimento",
  },
];

export const filterList: FilterOption = {
  policeman: {
    icon: <PeoplesSafe />,
    active: true,
    tooltip: "Agentes em Ocorrência",
  },
  policemanOnDuty: {
    icon: <PeoplesSafeOffline />,
    active: true,
    tooltip: "Agentes de Prontidão",
  },
  occVehicle: {
    icon: <Car />,
    active: true,
    tooltip: "Ocorrências Veiculares",
  },
  occPatrimony: {
    icon: <Home />,
    active: true,
    tooltip: "Ocorrências Patrimôniais",
  },
  store: {
    icon: <Shop />,
    active: true,
    tooltip: "Estabelecimentos",
  },
};
